'use client';
import { useEffect } from 'react';
 import Icon from'@/components/ui/AppIcon';

const HowItWorksSection = () => {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals.length) return
    
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals.forEach(el => observer.observe(el))
  }, [])

  const steps = [
    {
      id: 'step_select',
      number: '01',
      icon: 'FolderIcon',
      title: 'Select Topics',
      description: 'Choose from categories and specific topics you want to focus on. Customize your study session.',
    },
    {
      id: 'step_study',
      number: '02',
      icon: 'BookOpenIcon',
      title: 'Study or Test',
      description: 'Pick study mode for explanations or test mode for exam simulation. Set question count and timer.',
    },
    {
      id: 'step_review',
      number: '03',
      icon: 'ChartBarIcon',
      title: 'Review Results',
      description: 'Get instant feedback, detailed explanations, and track your progress across all topics.',
    },
  ]

  return (
    <section className="py-24 bg-muted">
      <div className="container px-6">
        <div className="text-center mb-16 reveal">
          <span className="text-sm font-semibold text-primary uppercase tracking-wider mb-3 block">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight mb-4">
            Three Simple Steps
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Start studying in minutes with our intuitive platform designed for aviation students.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <div key={step.id} className="relative reveal" style={{ animationDelay: `${index * 0.1}s` }}>
              {/* Connecting Line (Desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-border -translate-x-1/2 z-0" />
              )}

              <div className="relative bg-card rounded-2xl p-6 sm:p-8 border border-border shadow-sm hover:shadow-lg transition-shadow z-10">
                {/* Step Number */}
                <div className="absolute -top-4 -right-4 w-10 h-10 sm:w-12 sm:h-12 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs sm:text-sm font-bold shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-4 sm:mb-6">
                  <Icon name={step.icon as any} size={28} className="sm:w-8 sm:h-8" />
                </div>

                {/* Content */}
                <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 sm:mb-3">
                  {step.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection